import {
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
	TemplateRef,
	ViewChild
} from '@angular/core';
import { CalendarEvent } from 'angular-calendar';
import { FacadeService } from 'src/app/core/services/facade.service';
import { EmployeeService } from 'src/app/core/services/api/employee/employee.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { Vacation, VacationType } from 'src/app/shared/models/vacation';
import { Employee } from 'src/app/shared/models/employee/employee';
import { User } from 'src/app/shared/models/security/user';
import { PARAM_LABEL_INTERVENANT } from 'src/app/core/services/constant/constants.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Authority } from 'src/app/shared/models/security/authority';

@Component({
	selector: 'app-create-vacation',
	templateUrl: './create-vacation.component.html',
	styleUrls: ['./create-vacation.component.scss']
})
export class CreateVacationComponent implements OnInit {
	vacation: Vacation = null;
	employeeToSet: Employee = null;
	employeesList: Employee[] = [];
	ddItfcAbsDefault = 'Sélectionnez ';
	ddItfcAbs = this.ddItfcAbsDefault;
	ddTypeAbsDefault = "Sélectionnez le type d'absence";
	ddTypeAbs = this.ddTypeAbsDefault;

	employeeSelectedIndex;

	datesList: Date[] = [];
	isEventRecurring = false;

	@ViewChild('modalAbsenceEvent', { static: true })
	modalAbsenceEvent: TemplateRef<any>;
	@Input() dragToSelectEvent: CalendarEvent;
	@Input() vacationTypes: VacationType[];
	@Output() getDataForPlanning: EventEmitter<any> = new EventEmitter();
	@Output() cleanPlanning: EventEmitter<any> = new EventEmitter();

	bsRangeValue: Date[];
	bsValue = new Date();
	maxDate = new Date();

	currentLoggedInEmployeeId: number;
	currentUserAuthority: number;
	user: User = null;

	labelIntervenantCapitalized: string;

	modalAbs: BsModalRef;

	isNotPlanif = true;
	isAddingButtonAvailable = true;

	@Input() isVacationCreationAllowed = false;

	constructor(
		private employeeService: EmployeeService,
		private modalService: BsModalService,
		private logger: LogService,
		private facade: FacadeService
	) {}

	ngOnInit(): void {
		this.labelIntervenantCapitalized =
			this.facade.dataStorageService.getLabelCapitalized(
				PARAM_LABEL_INTERVENANT
			);
		this.ddItfcAbsDefault += this.labelIntervenantCapitalized;

		this.user = this.facade.dataStorageService.getUser();
		this.currentUserAuthority = this.user?.role.id;
		if (
			this.currentUserAuthority === Authority.INTERVENANT ||
			this.currentUserAuthority === Authority.CHARGE_MISSION
		) {
			this.currentLoggedInEmployeeId = this.user.employee.id;
			this.isNotPlanif = true;
		} else {
			this.isNotPlanif = false;
		}
	}

	openCreateAbsenceModal(empToSet?: Employee) {
		if (!this.isVacationCreationAllowed) {
			this.cleanPlanning.emit('temp');
		} else {
			this.facade.employeeService.getAllActiveEmployees().subscribe({
				next: (employees: Employee[]) => {
					this.employeesList = employees;
				},
				error: (err) => {
					this.logger.log(
						'' + err.status + ' ' + err.error.response ? err.error.response : ''
					);
					this.facade.toastService.createHttpErrorToast(
						err.error.response ? err.error.response : '',
						err.status
					);
				}
			});
			this.modalAbs = this.modalService.show(this.modalAbsenceEvent, {
				class: 'modal-lg'
			});
			this.createNewAbsence(empToSet);
			this.modalAbs.onHide.subscribe(() => {
				this.employeeToSet = null;
				this.cleanPlanning.emit('temp');
				// this.refreshDataInPlanning.emit();
			});
		}
	}

	changeDate() {
		if (this.vacation.startDate !== this.bsRangeValue[0]) {
			// this.dragToSelectEvent.start = this.bsRangeValue[0];
			this.vacation.startDate = this.bsRangeValue[0];
		}
		if (this.vacation.endDate !== this.bsRangeValue[1]) {
			// this.dragToSelectEvent.end = this.bsRangeValue[1];
			this.vacation.endDate = this.bsRangeValue[1];
		}
	}

	createNewAbsence(empToSet?: Employee) {
		this.ddItfcAbs = this.ddItfcAbsDefault;
		this.ddTypeAbs = this.ddTypeAbsDefault;
		this.vacation = new Vacation();
		this.setDatesToAbs();
		this.bsValue = this.dragToSelectEvent?.start;
		this.maxDate = this.dragToSelectEvent?.end;
		this.bsRangeValue = [this.bsValue, this.maxDate];

		if (
			this.currentUserAuthority === Authority.INTERVENANT ||
			this.currentUserAuthority === Authority.CHARGE_MISSION
		) {
			this.employeeService
				.getEmployeeById(this.currentLoggedInEmployeeId)
				.subscribe({
					next: (employee: Employee) => {
						this.logger.log('employee : ', employee);
						this.ddItfcAbs = `${employee.firstName} ${employee.lastName}`;
						this.employeeToSet = employee;
						this.vacation.employeeId = this.currentLoggedInEmployeeId;
					},
					error: (err) => {
						this.logger.log(
							'' + err.status + ' ' + err.error.response
								? err.error.response
								: ''
						);
						this.facade.toastService.createHttpErrorToast(
							err.error.response ? err.error.response : '',
							err.status
						);
					}
				});
		} else if (empToSet && empToSet.id) {
			this.selectItfcAbs(empToSet);
		}
	}

	setDatesToAbs(vacation?: Vacation) {
		if (this.dragToSelectEvent) {
			if (vacation) {
				vacation.startTime =
					this.dragToSelectEvent.start.getHours() * 60 +
					this.dragToSelectEvent.start.getMinutes();
				vacation.endTime =
					this.dragToSelectEvent.end.getHours() * 60 +
					this.dragToSelectEvent.end.getMinutes();
				return vacation;
			} else {
				this.vacation.startTime =
					this.dragToSelectEvent.start.getHours() * 60 +
					this.dragToSelectEvent.start.getMinutes();
				this.vacation.endTime =
					this.dragToSelectEvent.end.getHours() * 60 +
					this.dragToSelectEvent.end.getMinutes();
				this.vacation.startDate = new Date(
					new Date(this.dragToSelectEvent.start).setHours(0, 0, 0, 0)
				);
				this.vacation.endDate = new Date(
					new Date(this.dragToSelectEvent.end).setHours(0, 0, 0, 0)
				);
			}
		}
	}

	selectAbsenceType(vacationType: any) {
		this.ddTypeAbs = vacationType.type;
		this.vacation.vacationType = vacationType;
	}

	selectItfcAbs(itfc: any) {
		this.ddItfcAbs = `${itfc.firstName} ${itfc.lastName}`;
		this.employeeToSet = itfc;
		this.vacation.employeeId = itfc.id;
	}

	parseJson(value) {
		return JSON.parse(value);
	}

	setModifiedTime() {
		const minStart =
			this.dragToSelectEvent.start.getHours() * 60 +
			this.dragToSelectEvent.start.getMinutes();
		const minEnd =
			this.dragToSelectEvent.end.getHours() * 60 +
			this.dragToSelectEvent.end.getMinutes();
		if (minStart !== this.vacation?.startTime) {
			this.vacation.startTime = minStart;
		}
		if (minEnd !== this.vacation?.endTime) {
			this.vacation.endTime = minEnd;
		}
	}

	confirmAbsence() {
		this.setModifiedTime();
		let listRecurringVacation: Vacation[] = [];
		this.isAddingButtonAvailable = false;

		if (this.vacation?.vacationType && this.employeeToSet) {
			if (this.isEventRecurring && this.datesList.length > 0) {
				this.datesList.forEach((date) => {
					const vacation = new Vacation({
						vacationType: this.vacation.vacationType,
						startTime: this.vacation.startTime,
						endTime: this.vacation.endTime,
						startDate: new Date(new Date(date).setHours(0, 0, 0, 0)),
						endDate: new Date(new Date(date).setHours(0, 0, 0, 0)),
						employeeId: this.employeeToSet.id,
						notes: this.vacation.notes
					});
					listRecurringVacation.push(vacation);
				});
			} else {
				listRecurringVacation.push(this.vacation);
			}

			this.facade.vacationService
				.addVacationForEmployee(listRecurringVacation, this.employeeToSet.id)
				.subscribe({
					next: (succ) => {
						this.isAddingButtonAvailable = true;
						this.ddItfcAbs = this.ddItfcAbsDefault;
						this.vacation = null;
						this.employeeToSet = null;
						this.datesList = null;
						this.isEventRecurring = false;
						this.modalAbs.hide();
						this.getDataForPlanning.emit({
							reloadEmployeesAndVacation: true,
							reloadSolution: true,
							reloadOptimInProgress: true
						});
					},
					error: (err) => {
						this.isAddingButtonAvailable = true;
						this.facade.toastService.createHttpErrorToast(
							err.error.response ? err.error.response : '',
							err.status
						);
						this.logger.log(
							'' + err.status + ' ' + err.error.response
								? err.error.response
								: ''
						);
					}
				});

			listRecurringVacation = [];
		} else {
			this.isAddingButtonAvailable = true;
		}
	}

	onSwitchRecurrencyChange() {
		this.isEventRecurring = !this.isEventRecurring;
	}

	updateDateList(dates: Date[]) {
		this.datesList = dates;
	}
}
